module.exports = __webpack_public_path__ + "img/img4.697e59c0.png";